import { render, staticRenderFns } from "./OnboardClient.vue?vue&type=template&id=c8979c20&"
import script from "./OnboardClient.vue?vue&type=script&lang=js&"
export * from "./OnboardClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports